exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multiselect__option--group{background:#163247!important;color:#fff!important}.dropdown-menu.show{top:36px!important;transform:none!important}.tooltip .tooltip-inner{max-width:none!important}@media (max-width:576px){#checkoutFormGroup .dropdown-menu.show{right:0;left:auto!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58a73f38","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/make-your-bookings/MakeYourBookings.vue
// module id = 851
// module chunks = 0